import React from "react";
import "./JoinedUsers.css";
function JoinedUsers() {
  return (
    <div className="users__joined">
      <img
        className="imgg"
        src="https://cdn-icons-png.flaticon.com/512/147/147142.png"
        alt="user"
      />
      <p>Niranjan V</p>
      <p>-</p>
      <p className="user__country">India</p>
      <p className="follow">Follow</p>
    </div>
  );
}

export default JoinedUsers;
